module.exports = __webpack_public_path__ + "img/presale-header.4eca6d35.jpg";